<ckeditor
  [disabled]="disabled"
  [ngModel]="value"
  [editor]="editor"
  [config]="config"
  (ngModelChange)="onChange($event)"
  (ready)="onReady($event)"
  (blur)="onBlur()"
></ckeditor>
